import { useTranslation } from 'react-i18next';
import GeneralNotice from '@pelckmans/elementis/components/general-notice';

function ServiceNotAvailable() {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  const { t } = useTranslation();

  return (
    <GeneralNotice
      className="exercise-general-notice"
      data-testid="service-not-available"
      logoProps={{
        variant: REACT_APP_P_STUDIO_GROUP,
        'aria-label': 'logo',
      }}
      text={t('EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.TITLE')}
      subText={
        <>
          {t('EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.P1')}
          <br />
          {t('EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.P2')}
        </>
      }
    />
  );
}

export default ServiceNotAvailable;
